export enum FactureProformaStatus {
  BROUILLON = 'brouillon',
  VALIDEE = 'validee',
  ANNULEE = 'annulee',
}

export interface FactureProformaItem {
  id: number;
  facture_proforma_id: number;
  article_id?: number | null;
  designation: string;
  quantite: number;
  prix_unitaire: number;
  total: number;
  created_at: string;
}

export interface FactureProformaItemCreate {
  article_id?: number | null;
  designation: string;
  quantite: number;
  prix_unitaire: number;
  total: number;
}

export interface FactureProforma {
  id: number;
  reference: string;
  date: string;
  client_id: number;
  client_name?: string;
  client_ice?: string;
  client_address?: string;
  tva_rate: number;
  total_ht: number;
  tva_amount: number;
  total_ttc: number;
  condition_paiement_id?: number;
  mode_paiement_id?: number;
  delai_realisation?: number;
  remarque?: string;
  condition_paiement_nom?: string;
  mode_paiement_nom?: string;
  status: FactureProformaStatus | string;
  user_id?: number;
  user_name?: string;
  created_at: string;
  updated_at?: string;
  deleted_at?: string;
  items: FactureProformaItem[];
}

export interface FactureProformaCreate {
  date: string;
  client_id: number;
  tva_rate?: number;
  condition_paiement_id?: number | null;
  mode_paiement_id?: number | null;
  delai_realisation?: number | null;
  remarque?: string | null;
  items: FactureProformaItemCreate[];
}

export interface FactureProformaUpdate {
  date?: string;
  client_id?: number;
  tva_rate?: number;
  condition_paiement_id?: number | null;
  mode_paiement_id?: number | null;
  delai_realisation?: number | null;
  remarque?: string | null;
  status?: string;
  items?: FactureProformaItemCreate[];
}

export interface FactureProformaListResponse {
  total: number;
  items: FactureProforma[];
}
